import { ServiceSelectionMode } from "@salon/types";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import type { OnlineBookingConfig } from "../hooks/use-online-booking-config";
import { SelectionModeToggle } from "./selection-mode-toggle";

export function ServiceSelectionModeToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<OnlineBookingConfig>;
  saving: boolean;
}) {
  return (
    <SelectionModeToggle
      fieldName="serviceSelectionMode"
      onValue={ServiceSelectionMode.MULTIPLE}
      offValue={ServiceSelectionMode.SINGLE}
      i18nFieldKey="serviceSelection"
      saveField={saveField}
      saving={saving}
    />
  );
}
